import * as React from 'react'
import { Link } from 'react-router-dom'

import parse, { type DOMNode, Element, domToReact } from 'html-react-parser'

interface Props {
  html: string
}

const HTMLWithMentions = ({ html }: Props) => {
  function parseWithLinks(html: string) {
    const options = {
      replace: (domNode: DOMNode) => {
        if (domNode instanceof Element && domNode.name === 'a' && domNode.attribs) {
          if (domNode.attribs.href && domNode.attribs.class === 'link_mentioned') {
            return (
              <span onClick={(e) => e.stopPropagation()}>
                <Link to={domNode.attribs.href}>{domToReact(domNode.children)}</Link>
              </span>
            )
          }
        }
      },
    }

    return parse(html, options)
  }

  return <div>{parseWithLinks(html)}</div>
}

export default HTMLWithMentions
